// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const JsonldData = () => ({
   replace: true,
   template: '<script type="application/ld+json" ng-bind-html="vm.data"></script>',
   controllerAs: 'vm',
   controller: JsonldDataController
})

class JsonldDataController {
   $sce: any
   $scope: any
   data: any
   documentDetailService: any
   jsonldService: any
   constructor($sce: any, $scope: any, jsonldService: any, documentDetailService: any) {
      this.$onInit = this.$onInit.bind(this)
      this.mapDocument = this.mapDocument.bind(this)
      this.$sce = $sce
      this.$scope = $scope
      this.jsonldService = jsonldService
      this.documentDetailService = documentDetailService
      this.documentDetailService.on('new', this.mapDocument)
      this.$scope.$on('$destroy', () => this.documentDetailService.off('new', this.mapDocument))
   }

   $onInit() {
      return this.mapDocument()
   }

   mapDocument() {
      return this.data = this.$sce.trustAsHtml(JSON.stringify(this.jsonldService.mapDocumentToJsonld(this.documentDetailService.scope.doc)))
   }
}

JsonldDataController.$inject = ['$sce', '$scope', 'jsonldService', 'documentDetailService']

angular.module('summonApp.directives')
   .controller('jsonldDataController', JsonldDataController)
   .directive('jsonldData', [JsonldData])
